module.exports = __webpack_public_path__ + "components/flag/static/square/um-91c9714eae50570e65a4eef0aa6011ff.svg";